module.exports = __webpack_public_path__ + "static/tat-34-cfef4bc1a44f9494d3f057f89244f50e.jpg";